ThemeJS.Archive_Cards = (function ($) {

	const COLUMN_CLASS = 'archive-cards__column';
	const ITEM_SELECTOR = '.article-card, .article-card-skeleton';

	function get_column_count() {
		if (ThemeJS.Media_Queries.is_at_least('lg')) {
			return 4;
		}
		if (ThemeJS.Media_Queries.is_at_least('sm')) {
			return 2;
		}
		return 1;
	}

	function collect_items($grid) {
		const $from_columns = $grid.children('.' + COLUMN_CLASS).find(ITEM_SELECTOR);
		if ($from_columns.length) {
			return $from_columns;
		}
		return $grid.children(ITEM_SELECTOR);
	}

	function get_cards($grid, refresh) {
		if (refresh) {
			$grid.removeData('archiveCards');
		}

		let $cards = $grid.data('archiveCards');
		if ($cards && $cards.length) {
			return $cards;
		}

		$cards = collect_items($grid);
		$grid.data('archiveCards', $cards);
		return $cards;
	}

	function layout($grid, options) {
		$grid = $($grid);
		options = options || {};

		const $cards = get_cards($grid, options.refresh);
		if (!$cards.length) {
			$grid.removeAttr('data-columns');
			return;
		}

		const count = get_column_count();
		const $columns = [];

		for (let i = 0; i < count; i++) {
			$columns.push($('<div>', { class: COLUMN_CLASS }));
		}

		$cards.each(function (index) {
			$columns[index % count].append(this);
		});

		$grid
			.empty()
			.attr('data-columns', count)
			.append($columns);
	}

	function init(root) {
		const $root = root ? $(root) : $(document);
		$root.find('.archive-cards__grid').addBack('.archive-cards__grid').each(function () {
			layout($(this));
		});
	}

	$(function () {
		init();
	});

	$(window).on('breakpoint_changed', function () {
		init();
	});

	return {
		init,
		layout,
	};

})(jQuery);
